export function removeNulls<T extends Record<string, unknown>>(
  obj: T
): Partial<T> {
  return Object.entries(obj).reduce((acc, e) => {
    return e[1] ? { ...acc, [e[0]]: e[1] } : acc;
  }, {} as Partial<T>);
}
